/**
 * TogglePane for lbbw-am.de
 * Handhabt Tabs und Accordions
 *
 * @author Florian Gutwald
 * Converted to Plain JS for Rollup
 */
export default class TogglePane {
  static setState(root, target, expanded) {
    root.querySelectorAll(`[data-toggle-target="${target}"]`).forEach(panel => {
      panel.classList.toggle('toggle__active', expanded);
      panel.hidden = !expanded;
      panel.setAttribute('aria-hidden', String(!expanded));
    });
    // Desktop tabs and mobile accordion buttons control the same panels.
    root.querySelectorAll(`[data-toggle="${target}"]`).forEach(button => {
      button.classList.toggle('gui--toggle__active', expanded);
      button.setAttribute('aria-expanded', String(expanded));
      button.closest('.tabnav-item')?.classList.toggle('tabnav-item__active', expanded);
    });
  }

  static captureState(root) {
    const states = new Map();
    root.querySelectorAll('[data-toggle-target][aria-hidden]').forEach(panel => {
      states.set(panel.getAttribute('data-toggle-target'), panel.classList.contains('toggle__active'));
    });
    return states;
  }

  static restoreState(root, states) {
    states.forEach((expanded, target) => TogglePane.setState(root, target, expanded));
  }

  /**
   * @param {Object} options
   */
  constructor(options = {}) {
    this.settings = Object.assign({
      target: null,
      isTab: false
    }, options);

    this.init();
  }

  init() {
    const target = this.settings.target;
    const isTab = this.settings.isTab;

    //console.log('TogglePane init', target, isTab);

    const toggleTarget = document.querySelectorAll(`[data-toggle-target="${target}"]`);
    if (toggleTarget.length === 0) return;

    if (isTab) {
      this.handleTab(target);
    } else {
      this.handleAccordion(target, toggleTarget);
    }

    // Tab-Titel aktualisieren
    const tabTitleEl = document.getElementById('tab_title');
    if (tabTitleEl) {
      tabTitleEl.textContent = toggleTarget[0].getAttribute('title') || '';
    }
  }

  handleTab(target) {
    console.log('TogglePane handleTab', target);

    // Alle Tab-Buttons und deren Container finden
    const allToggleButtons = document.querySelectorAll('[data-toggle].js_tab');

    allToggleButtons.forEach(btn => {
      TogglePane.setState(document, btn.getAttribute('data-toggle'), false);
    });

    // Aktuellen Tab aktivieren
    TogglePane.setState(document, target, true);

    // Custom Event für Charts etc.
    if (target === 'zusammensetzung') {
      document.dispatchEvent(new CustomEvent('togglePane:zusammensetzung'));
    }

    // URL Hash aktualisieren ohne Scroll
    if (window.history.replaceState) {
      window.history.replaceState(null, null, `#${target}`);
    } else {
      window.location.hash = target;
    }
  }

  handleAccordion(target, toggleTarget) {
    console.log('TogglePane ELSE (Accordion)', target);
    const currentlyActive = toggleTarget[0].classList.contains('toggle__active');
    const newState = !currentlyActive;

    // Match the legacy accordion behavior without closing tab panels.
    document.querySelectorAll('[data-toggle]:not(.js_tab)').forEach(btn => {
      const id = btn.getAttribute('data-toggle');
      if (id !== target) {
        TogglePane.setState(document, id, false);
      }
    });
    TogglePane.setState(document, target, newState);
  }

  /**
   * Statische Methode für den direkten Aufruf (Ersatz für $.togglePane)
   */
  static toggle(target, isTab = false) {
    return new TogglePane({ target, isTab });
  }

  /**
   * Statische Methode für den direkten Aufruf (Ersatz für $.togglePane)
   */
  static handleHashOnLoad() {
    const hash = window.location.hash.slice(1); // Entferne das '#'
    const querySelector = document.querySelectorAll(`[data-toggle-target="${hash}"]`);
    if (hash && querySelector.length > 0) {
      //console.log('TogglePane:handleHashOnLoad', hash, querySelector);
      // Kleines Timeout, um sicherzustellen, dass alle Elemente geladen sind
      setTimeout(() => {
        TogglePane.toggle(hash, true); // true für Tab
      }, 1000);
    }
  }
}
